export const layoutItems = '/api/stencil_layout';
export const layoutPreview = '/stencils/preview';
export const newImage = '/api/stencil/images';
export const newTextItem = '/api/stencil/text_items';
